import React from "react";
import {BrandsData} from "../../interfaces/BrandsData";
import {chunkArray} from "../../util";

export function Brands({data, pr}: { data: BrandsData, pr: boolean }) {

    return (
        <div className="bg-gray-50 p-10">
            <div className="md:w-6/12 mx-auto">
                <img src={data.logo} alt="logo" className="md:w-1/3 w-2/3 mx-auto"/>
                <div className="md:w-1/5 w-2/5 my-8 mx-auto border-b border-1 border-black"/>
                <div className="text-center font-semibold mt-10 text-sm">{data.tittle}</div>
                <div className="text-center text-xs">{data.description}</div>
                {!pr &&
                    <div className="flex flex-col gap-4 my-6">
                        {/* Mobile: una sola columna */}
                        <div className="flex flex-col gap-8 md:hidden">
                            {data.brands.map((item: any, index: any) => (
                                <a href={item.url} target="_blank" key={index}>
                                    <img src={item.logo} alt="brand" className="w-full"/>
                                </a>
                            ))}
                        </div>

                        {/* Desktop: filas de 4 centradas */}
                        <div className="hidden md:block">
                            {chunkArray(data.brands, 4).map((row, rowIndex) => (
                                <div key={rowIndex} className="w-4/5 m-auto flex justify-center gap-8">
                                    {row.map((item: any, index: any) => (
                                        <a href={item.url} target="_blank" key={index} className="w-24 flex-none">
                                            <img src={item.logo} alt="brand" className="w-full"/>
                                        </a>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                }
                {pr &&
                    <div className="w-1/3 md:w-4/5 m-auto my-8">
                        {/* Mobile: una sola columna */}
                        <div className="flex flex-col gap-8 md:hidden">
                            {data.brands.map((item: any, index: any) => (
                                <a href={item.url} target="_blank" key={index}>
                                    <img src={item.logo} alt="brand" className="w-full"/>
                                </a>
                            ))}
                        </div>

                        {/* Desktop: filas de 4 centradas */}
                        <div className="hidden md:block">
                            {chunkArray(data.brands, 4).map((row, rowIndex) => (
                                <div key={rowIndex} className="flex justify-center gap-8 mb-8">
                                    {row.map((item: any, index: any) => (
                                        <a href={item.url} target="_blank" key={index} className="w-24 flex-none">
                                            <img src={item.logo} alt="brand" className="w-full"/>
                                        </a>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}